import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { UnauthorizedInterceptor } from './auth/services';
import { environment } from '../environments/environment';
import { GraphQLModule, GRAPHQL_ERROR_HANDLERS } from './@graphql';
import { CoreAuthModule } from './@core-auth';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthModule } from './auth/auth.module';
import { APP_NAME_TAG, SETTINGS_PROVIDER } from './settings.config';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { translateLoaderFactory } from './@core/utils/translate-loader.service';
import { CoreUIModule } from './@core-ui'
import { pl } from 'date-fns/locale';
///import { NbDateFnsDateModule } from '@nebular/date-fns';
import { NbMomentDateModule } from '@nebular/moment';

import '@angular/common/locales/global/pl'

import {
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbToastrService,
  NbWindowModule,
} from '@nebular/theme';
import { I18nModule } from './i18n/i18n.module';
import { NgxEchartsModule } from 'ngx-echarts';
import { AddTokenInterceptor } from './auth/services/add-token-interceptor.service';
import { OfflineErrorHandler } from './@core-ui/errors/offline-error-handler.service';
import { ApiErrorHandler } from './@core-ui/errors/api-error-handler.service';
import { GRAPHQL_CONFIG } from './@graphql';

const APP_INTERCEPTORS = [
  { provide: HTTP_INTERCEPTORS, useClass: AddTokenInterceptor, multi: true},
  { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
  { provide: GRAPHQL_ERROR_HANDLERS, useClass: OfflineErrorHandler, deps: [TranslateService, NbToastrService], multi: true },
  { provide: GRAPHQL_ERROR_HANDLERS, useClass: ApiErrorHandler, deps: [TranslateService, NbToastrService], multi: true },
  { provide: LOCALE_ID, useValue: 'pl' }
];

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [GraphQLModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbMomentDateModule,
        /*
        NbDateFnsDateModule.forRoot({
          parseOptions: { locale: pl },
          formatOptions: { locale: pl },
          //format: 'MMM dd, yyyy'
          format: 'dd/MM/yyyy'
        }),
        */
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        AuthModule,
        ThemeModule.forRoot(),
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NbDialogModule.forRoot(),
        NbWindowModule.forRoot(),
        NbToastrModule.forRoot(),
        CoreModule.forRoot(),
        CoreUIModule.forRoot(),
        TranslateModule.forRoot({
            loader: { provide: TranslateLoader, useFactory: translateLoaderFactory, deps: [HttpClient] }
        }),
        CoreAuthModule,
        I18nModule,
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts')
        })], providers: [SETTINGS_PROVIDER,
        ...APP_INTERCEPTORS,
        {
            provide: GRAPHQL_CONFIG,
            useValue: {
                url: environment.graphQLUrl
            }
        }, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
